import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createGtag } from "vue-gtag";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { sentryApi } from "./api/sentry";
import { useSessionStore } from "./store/session";

void (async function () {
    const pinia = createPinia();
    const session = useSessionStore(pinia);
    const [sentry] = await Promise.all([sentryApi.config().catch(() => null), session.restore(), session.loadVersion()]);

    const app = createApp(App);
    if (sentry?.dsn) {
        Sentry.init({
            app,
            dsn: sentry.dsn,
            tunnel: "/tunnel",
            release: sentry.release ?? undefined,
            environment: sentry.environment ?? undefined,
            debug: sentry.debug,
            integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
            tracesSampleRate: 1.0,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1.0,
        });
        session.trackUser();
    }
    app.use(pinia)
        .use(router)
        .use(vuetify)
        .use(createGtag({ tagId: "G-LB2NGT87M0" }));
    await router.isReady();
    app.mount("#app");
})();
